// extracted by mini-css-extract-plugin
module.exports = {"mb18":"index-module_mb18_1VNVT","textarea":"index-module_textarea_1f5WF","language":"index-module_language_37PLb"};